import React, { Fragment } from 'react';
import { AnyAction } from 'redux';
import { AppState } from '../store'
import { Typography } from '@material-ui/core';

export default (state: AppState, dispatch: React.Dispatch<AnyAction>) => {

    return {
        name: "GetReady",
        label: "Prepare yourself",
        content: (
            <Fragment>
                <Typography>Prepare yourself</Typography>
            </Fragment>
        )
    }
}